import { useState, useCallback } from 'react';
import {
  useListAllBlogPostsAdminQuery,
  useCreateBlogPostMutation,
  useUpdateBlogPostMutation,
  useDeleteBlogPostMutation,
} from '@/api/client';
import type {
  BlogPostListItemSchema,
  CreateBlogPostRequestSchema,
  UpdateBlogPostRequestSchema,
} from '@/api/client';

export function useBlog(skip: boolean) {
  const [editingId, setEditingId] = useState<number | null>(null);

  const { data, isLoading, refetch } = useListAllBlogPostsAdminQuery(
    { page: 1, size: 100 },
    { skip }
  );

  const [createMutation, { isLoading: isCreating }] = useCreateBlogPostMutation();
  const [updateMutation, { isLoading: isUpdating }] = useUpdateBlogPostMutation();
  const [deleteMutation, { isLoading: isDeleting }] = useDeleteBlogPostMutation();

  const posts: BlogPostListItemSchema[] = data?.items ?? [];

  const createPost = useCallback(
    async (body: CreateBlogPostRequestSchema) => {
      await createMutation(body).unwrap();
      refetch();
    },
    [createMutation, refetch]
  );

  const updatePost = useCallback(
    async (blogPostId: number, body: UpdateBlogPostRequestSchema) => {
      await updateMutation({ blogPostId, updateBlogPostRequestSchema: body }).unwrap();
      setEditingId(null);
      refetch();
    },
    [updateMutation, refetch]
  );

  const deletePost = useCallback(
    async (blogPostId: number) => {
      await deleteMutation(blogPostId).unwrap();
      refetch();
    },
    [deleteMutation, refetch]
  );

  return {
    posts,
    isLoading,
    isCreating,
    isUpdating,
    isDeleting,
    editingId,
    setEditingId,
    createPost,
    updatePost,
    deletePost,
  };
}
